import {
  bootstrapApplication,
} from "./bootstrapApplication";
import "./index.css";

bootstrapApplication();